import * as React from 'react';
import { iconAnalytics } from '../../icons';
import { BackofficeRoute } from '../../types/route.interfaces';
import AnalyticsPage from './pages/AnalyticsPage';

const dashboardRoutes: BackofficeRoute[] = [
  {
    sidebar: {
      icon: iconAnalytics,
      translationKey: 'menu.analytics',
    },
    path: '/dashboard',
    element: <AnalyticsPage />,
  },
];

export default dashboardRoutes;
